import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './tabler.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {msalConfig} from "./Config/EntraAuthConfig";
import {PublicClientApplication} from "@azure/msal-browser";
import {AuthProvider} from "./Context/AuthContext";
import {MsalProvider} from "@azure/msal-react";

const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <AuthProvider>
                <App />
            </AuthProvider>
        </MsalProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
